import React, { Component } from 'react';
import '../../../../styles/variables.css';
import './AddCompany.css';
import {ShowNotification} from '../../../../components/HandleNotifications';
import {firebase} from '../../../../firebase/firebase';
import database from '../../../../firebase/firebase';
import axios from 'axios';
import {NotificationContainer} from 'react-notifications';
axios.defaults.headers.post.Accept = "application/json";
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Methods"] = "ET, POST, PUT, DELETE";
axios.defaults.headers["Access-Control-Allow-Headers"] = "Authorization";

class Students extends Component {

    state = {
        error: null,
        showMessage: false,
        message: '',
        password: '',
        company: {
            companyName: '',
            locationName: '',
            onCreate: true,
            data: '',
            companyAbout: '',
            active: true,
            companyEmail: '',
            objectID: '',
            companyLogo: ''
        }
    };
    
    handleInputChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        if(name === "password"){
            this.setState({password: value})
        }else{
        this.setState(prevState => {
            let company = Object.assign({}, prevState.company);
            company[name] = value;       
            return { company };                           
        });
    }
    };

    handleErrors = (error) => {
        let m =''
        switch (error.code) {
            case 'auth/invalid-email':
                m = 'Error en el correo';
                this.setState({message: 'El correo que proporcionaste no tiene un formato valido, por favor verificalo.'});
                break;
            case 'auth/email-already-in-use':
                m = 'Correo en uso';
                this.setState({message: 'El correo que proporcionaste esta actualmente en uso, si ya tienes una cuenta por favor ',
                    goLogin: true});
                break;
            case 'auth/weak-password':
                m = 'La contraseña es muy corta';
                this.setState({message: 'La contraseña debe de ser de al menos seis caracteres, por favor introduce una nueva e intantalo de nuevo.', goLogin: false});
                break;
            case 'auth/invalid-password':
            m = 'La contraseña no es valida';
            this.setState({message: 'La contraseña debe de ser de al menos seis caracteres, por favor introduce una nueva e intantalo de nuevo.', goLogin: false});
            break;
            default:
                m=error.code
                this.setState({message: error.message, goLogin: false});
                break;
        }
        return m;
    } 

    clearInputs = () =>{
        this.setState({
            error: null,
            showMessage: false,
            message: '',
            password: "",
            company:{
                companyName: '',
                locationName: '',
                onCreate: true,
                data: '',
                companyAbout: '',
                active: true,
                companyEmail: '',
                objectID: '',
                companyLogo: ''
            }
        })
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        const {password} = this.state;
        let companyEmail = this.state.company.companyEmail;
        axios.request({
            url: "https://us-central1-universia-dev.cloudfunctions.net/company-register",
            method: "POST",
            data: {email: companyEmail, password: password},
            crossDomain: true
        }).then(res => {
            if(!!res.data.code){
                let message = this.handleErrors(res.data);
                this.setState({showMessage : true});
                ShowNotification('error', message, 'Algo salio mal');
                this.setState({error : res.data.code});
            }else{
                this.setState(prevState => {
                    let company = Object.assign({}, prevState.company);
                    company.objectID = res.data;       
                    return { company };                           
                });
                database.collection(`companies`)
                .doc(`${res.data}`)
                .set(this.state.company, {merge: true}).then(()=>{
                    ShowNotification('success', 'Se registro la empresa exitosamente', 'Listo!');
                    this.clearInputs();
                })
            }
        })
    };

    render(){
        return(
            <div className="container">
                <div className='a-main-card'>
                    <div className="adt">
                        <p className="-title">Agregar Nueva Empresa</p>
                    </div>
                    <div className="a-form-left">
                        <label className="a-label-company" htmlFor="companyName">Nombre de la Empresa</label>
                        <input id="companyName" type="text" name="companyName" onChange={this.handleInputChange}
                        className="a-input-company" value={this.state.company.companyName}/>
                        <label className="a-label-company" htmlFor="companyEmail">Correo Electronico</label>
                        <input type="text" id="companyEmail" name="companyEmail" onChange={this.handleInputChange}
                        className="a-input-company" value={this.state.company.companyEmail}/>
                    </div>
                    <div className="a-form-right">
                        <label className="a-label-company" htmlFor="companyLocation">Ubicación</label>
                        <input id="companyLocation" type="text" name="locationName" onChange={this.handleInputChange}
                        className="a-input-company" value={this.state.company.locationName}/>
                        <label className="a-label-company" htmlFor="companyPassword">Contraseña Temporal</label>
                        <input id="companyPassword" type="password" name="password" onChange={this.handleInputChange}
                        className="a-input-company" value={this.state.password}/>
                    </div>
                    <div className="clear"></div>
                    <div className="a-form-desc">
                        <label htmlFor="companyDescription" className="a-label-company">Descripciòn de la empresa</label>
                        <textarea className="asds" id="companyDescription" name="data" onChange={this.handleInputChange}
                         rows="3" value={this.state.company.data}></textarea>
                        <label htmlFor="companyHistory" className="a-label-company">Un poco de historia</label>
                        <textarea id="companyHistory" name="companyAbout" onChange={this.handleInputChange}
                        className="asds" rows="3" value={this.state.company.companyAbout}></textarea>
                    </div>
                    <div className="a-form-button">
                        <button className="a-button-company" onClick={this.handleSubmit}>Agregar Empresa</button>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        )
    }
}

export default Students;